module.exports = __webpack_public_path__ + "img/1.ede8349a.png";